import { Box, Tab, Tabs } from "@mui/material";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { Col } from "reactstrap";
import AssistanceInfoFromReminder from "./AssistanceInfoFromReminder";


type ReminderNavBarType = {
    childrenColumnSize?: number;
    reminderAssistanceNumber?: string | null;
};

export function ReminderNavBar({ childrenColumnSize = 12, reminderAssistanceNumber }: ReminderNavBarType) {

    const intl = useIntl();
    const [activeTab, setActiveTab] = useState<number>(0);
    const { id } = useParams<{ id: string }>();

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);
    };

    return (
        <>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                    value={activeTab}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    variant="scrollable"
                    scrollButtons
                    allowScrollButtonsMobile
                >
                    <Tab label={intl.formatMessage({ id: "Screens.Reminder.Navbar.AssistanceInfo" })} {...a11yProps(0)} />
                </Tabs>
            </Box>

            <TabPanel value={activeTab} index={0} childrenColumnSize={childrenColumnSize}>
                <AssistanceInfoFromReminder
                    reminderId={id ?? null}
                    reminderAssistanceNumber={reminderAssistanceNumber ?? null}
                     />
            </TabPanel>            
        </>
    );
}

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
    childrenColumnSize: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, childrenColumnSize, ...other } = props;

    return (
        <Col xl={childrenColumnSize}>
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && <>{children}</>}
            </div>
        </Col>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}
